export default "__VITE_ASSET__BBESMWRj__"